module.exports = __webpack_public_path__ + "img/intercept.d73e5bdd.png";